import { DateTime } from 'luxon';
import { FlexCal, FlexCalSummary } from '../types';

//Set the initial load date of the FullCalendar component
const getInitialDate = (flexCal: FlexCalSummary | FlexCal) => {
  const now = DateTime.now();
  //The date will be now if the FlexCal (Scheduling Link) is evergeen
  if (flexCal?.evergreen) return now;
  //If this is a fixed date FlexCal (Scheduling Link) and it has started already, the date will be now
  if (DateTime.fromISO(flexCal?.startDate) < now) {
    return now;
  }
  //If this is a fixed date FlexCal (Scheduling Link) and it has not started already, the date will be the FlexCal start date
  return DateTime.fromISO(flexCal?.startDate);
};

export default getInitialDate;
